(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('VirtualNumberDetailController', VirtualNumberDetailController);

    VirtualNumberDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'VirtualNumber', 'CloudPBX'];

    function VirtualNumberDetailController($scope, $rootScope, $stateParams, previousState, entity, VirtualNumber, CloudPBX) {
        var vm = this;

        vm.virtualNumber = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('telestatApp:virtualNumberUpdate', function(event, result) {
            vm.virtualNumber = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
